import { Link, useRouterState, type ToPathOption } from '@tanstack/react-router';
import { type LucideIcon } from 'lucide-react';

import { SidebarMenuButton, SidebarMenuItem } from '@/shared/components/shadcn/sidebar';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { cn } from '@/shared/utils/cn';

const getGroupClassName = (isActive: boolean) => {
  return cn(
    'group hover:bg-sidebar-accent flex flex-1 cursor-pointer items-center gap-2 rounded-sm p-2 text-sidebar-foreground font-medium',
    '[&:hover>span]:text-sidebar-accent-foreground',
    isActive && 'bg-sidebar-accent [&>span]:text-sidebar-accent-foreground',
  );
};

export const MenuItem = ({
  route,
  name,
  Icon,
}: {
  route: ToPathOption;
  name: string;
  Icon: LucideIcon;
}) => {
  const routeId = useRouterState({
    select: (state) => state.matches.at(-1)?.routeId,
  });
  const { workspaceId } = useWorkspaceId();
  return (
    <SidebarMenuItem className="flex-1">
      <Link to={route} params={{ workspaceId }} className={getGroupClassName(routeId === route)}>
        <Icon className="size-4" />
        <span className={cn('text-sm')}>{name}</span>
      </Link>
    </SidebarMenuItem>
  );
};

export const CollapsedMenuItem = ({
  route,
  name,
  Icon,
}: {
  route: ToPathOption;
  name: string;
  Icon: LucideIcon;
}) => {
  const routeId = useRouterState({
    select: (state) => state.matches.at(-1)?.routeId,
  });
  const { workspaceId } = useWorkspaceId();
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild tooltip={name} isActive={routeId === route}>
        <Link to={route} params={{ workspaceId }}>
          <Icon className="size-4" />
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
